import * as React from 'react'
import { Tour } from '../../shared/Tour'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { useEffect } from 'react'

export const ViewSimulationTour = ({ tourState, onTourStatechange }) => {
  const [tourOpen, setTourOpen] = React.useState(tourState)
  const tourSteps = [
    {
      selector: '.tour-step-1',
      content: ({ goTo, step }) => (
        <div>
          Welcome to our simulation model for infectious disease, we will walk you through the basics of our model to
          get you started. <br /><br /> If you ever need a reminder you can open this tutorial up again by clicking the
          highlighted information button
          {getNavigation(step, goTo)}
        </div>
      ),
    },
    {
      selector: '.tour-step-2',
      content: ({ goTo, step }) => (
        <div>
          Use the sliders in the right side bar to control how the virus spreads and the impact on the
          population. <br /><br /> For more precise control you can enter the exact figure into the box above the slider
          {getNavigation(step, goTo)}
        </div>
      ),
    },
    {
      selector: '.tour-step-3',
      content: ({ goTo, step }) => (
        <div>
          After you have adjusted the sliders to create a scenario of a particular virus you can store the scenario to
          compare against other scenarios you create. Each scenario generates a unique link that you can return to at a
          later date. <br /><br /> Reset clears all scenarios you have created and returns the sliders all back to their
          default values
          {getNavigation(step, goTo)}
        </div>
      ),
    },
    {
      selector: '.tour-step-4',
      content: ({ goTo, step }) => (
        <div>
          The charts highlight the 4 key population impacts of a virus. As you interact with the sliders in the right
          panel, these charts will update instantly.
          {getNavigation(step, goTo)}
        </div>
      ),
    },
    {
      content: ({ goTo, step }) => (
        <div>
          The charts highlight the 4 key population impacts of a virus. As you interact with the sliders in the right
          panel, these charts will update instantly.
          {getNavigation(step, goTo)}
        </div>
      ),
    },
  ]

  function getNavigation(step, goTo) {
    return (
      <div className={'tour-custom-nav'}>
        {1 !== step && <div onClick={() => goTo(step - 2)} className={'tour-custom-nav__button'}>
          <ArrowBackIcon fontSize="small" />
          <span>Back</span>
        </div>}
        <div onClick={() => closeTour()} className={'tour-custom-nav__close'}>
          {tourSteps.length !== step && <span>Dont't show me again</span>}
          {tourSteps.length === step && <span className={'tour-custom-nav__button'}>
            <CheckCircleOutlineIcon fontSize="small" />
            Complete
          </span>}
        </div>
        {tourSteps.length !== step && <div onClick={() => goTo(step)} className={'tour-custom-nav__button'}>
          <span>Next</span>
          <ArrowForwardIcon fontSize="small" />
        </div>}
      </div>
    )
  }

  function closeTour() {
    setTourOpen(false)
    onTourStatechange(false)
    localStorage.setItem('ViewSimulationTour', '1')
  }

  useEffect(() => {
    tourState && setTourOpen(true)
  }, [tourState])

  return <Tour steps={tourSteps} isOpen={tourOpen} onRequestClose={closeTour} />
}
